export enum TemplatePlaceholderType {
	CALCULATION = 'CALCULATION',
	GROUPING = 'GROUPING',
	SELECTION = 'SELECTION'
}
